// Sub-collections bar — clickable arrow scroll

(function () {
  const SCROLL_STEP = 0.85;

  function svg(direction) {
    return direction === 'prev'
      ? '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function arrow(direction) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `gg-subcol-arrow gg-subcol-arrow--${direction}`;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Poprzednie' : 'Następne');
    btn.innerHTML = svg(direction);
    return btn;
  }

  function enhance(wrap) {
    if (wrap.dataset.ggSubcolArrows === '1') return;
    const list = wrap.querySelector('.gg-subcol-bar__list');
    if (!list) return;

    const prev = arrow('prev');
    const next = arrow('next');

    function recompute() {
      const max = list.scrollWidth - list.clientWidth - 1;
      if (max <= 4) {
        prev.classList.remove('is-active');
        next.classList.remove('is-active');
        return;
      }
      if (list.scrollLeft > 4) prev.classList.add('is-active');
      else prev.classList.remove('is-active');
      if (list.scrollLeft < max - 4) next.classList.add('is-active');
      else next.classList.remove('is-active');
    }

    prev.addEventListener('click', (e) => {
      e.preventDefault();
      list.scrollBy({ left: -list.clientWidth * SCROLL_STEP, behavior: 'smooth' });
    });
    next.addEventListener('click', (e) => {
      e.preventDefault();
      list.scrollBy({ left: list.clientWidth * SCROLL_STEP, behavior: 'smooth' });
    });

    list.addEventListener('scroll', recompute, { passive: true });
    window.addEventListener('resize', recompute, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(recompute).observe(list);
    }

    wrap.appendChild(prev);
    wrap.appendChild(next);
    wrap.dataset.ggSubcolArrows = '1';

    requestAnimationFrame(recompute);
    setTimeout(recompute, 100);
  }

  function scan(root) {
    (root || document).querySelectorAll('.gg-subcol-bar__carousel-wrap').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('gg-subcol-bar__carousel-wrap')) enhance(n);
        else if (n.querySelector) scan(n);
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
